export enum SaveSearchStoreEvent {
  searchSuccess = 'search-success',
  requestDeleteAll = 'request-delete-all',
}
